<template>
    <div
        class="md-house-detail standard"
        :style="{ marginBottom }"
        v-if="
            !(
                (countryConfig === 'canada' &&
                    !isOccupancyHasData &&
                    !isListingDetailHasData) ||
                isCensusSubdivision
            )
        "
    >
        <module-box
            class="house-detail"
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileNoMargin="mobileNoMargin"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
            noMargin
        >
            <div v-if="title" class="mg-title" v-html="formatFontSize(title, '--mg-title-size')"></div>
            <nbr-chart
                class="house-occupancy-chart"
                type="pie"
                :options="occupancyOptions"
                :title="$t('md-house-detail.occupancy')"
                :showAttom="true"
            >
            </nbr-chart>
            <div class="listing-detail">
                <h2 class="title">{{ $t('md-house-detail.listingDetail') }}</h2>
                <div class="table-content">
                    <div class="empty-data" v-if="detailEmpty">
                        <site-img
                            src="//cdn.chime.me/image/fs01/agnentinfo/20180305/22/original_5294514866269879.png"
                        >
                        </site-img>
                        <p class="text">
                            {{ $t('md-house-detail.comingSoon') }}
                        </p>
                    </div>
                    <div class="table-header">
                        <span>{{ $t('md-house-detail.attributes') }}</span>
                        <span>{{ $t('md-house-detail.average') }}</span>
                        <span>{{ $t('md-house-detail.median') }}</span>
                    </div>
                    <div class="table-body">
                        <div
                            v-for="item in houseDetails"
                            :key="item.name"
                            class="item"
                        >
                            <span class="name">{{ item.name }}</span>
                            <span class="average">{{ item.average }}</span>
                            <span class="median">{{ item.median }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </module-box>
    </div>
</template>

<script>
import common from '../index';
import nbrChart from '../../../components/nbr-chart/standard.vue';

export default {
    mixins: [common],
    computed: {
        occupancyOptions({ houseDetailInfo }) {
            let data = houseDetailInfo?.demographics?.households || {}
            const colors = ['#29dea2', '#bff1c2'];
            const seriesData = [
                {
                    name: 'Owned',
                    value: data.householdsOccupancyOwned
                },
                {
                    name: 'Rented',
                    value: data.householdsOccupancyRented
                }
            ];
            let context = this;
            seriesData.map((item, index) => {
                item.itemStyle = {
                    color: colors[index]
                };
                item.emphasis = {
                    itemStyle: {
                        color: colors[index]
                    }
                };
                item.label = {
                    formatter(params) {
                        let label = context.$t(
                            `md-house-detail.${params.name.toLowerCase()}`
                        );
                        return (
                            '{a|' +
                            Number(params.value).toFixed(1) +
                            '%}\n{b|' +
                            label +
                            '}'
                        );
                    }
                };
            });

            const baseOption = {
                legend: {
                    formatter: function(name) {
                        let label = context.$t(
                            `md-house-detail.${name.toLowerCase()}`
                        );
                        return (
                            '{a|' +
                            label +
                            '}{b|' +
                            Number(data['householdsOccupancy' + name]).toFixed(
                                0
                            ) +
                            '%}'
                        );
                    },
                    textStyle: {
                        fontSize: 12,
                        padding: [0, 0, 0, 5],
                        rich: {
                            a: {
                                color: '#9699a3',
                                fontSize: 14,
                                width: 55
                            },
                            b: {
                                color: '#5e646c',
                                fontSize: 16,
                                fontFamily: 'font-bold',
                                padding: [0, 0, 0, 20],
                                width: 50
                            }
                        }
                    }
                },
                series: [
                    {
                        data: seriesData
                    }
                ]
            };
            const chartOption = {
                baseOption: baseOption,
                media: [
                    {
                        query: {
                            maxWidth: 375
                        },
                        option: {
                            legend: {
                                formatter: function(name) {
                                    let tstr =
                                        'md-house-detail.' + name.toLowerCase();
                                    return (
                                        '{a|' +
                                        context.$t(tstr) +
                                        '}{b|' +
                                        Number(
                                            data['householdsOccupancy' + name]
                                        ).toFixed(0) +
                                        '%}'
                                    );
                                },
                                textStyle: {
                                    rich: {
                                        a: {
                                            align: 'left'
                                        },
                                        b: {
                                            align: 'left',
                                            padding: [5, 0, 0, 0]
                                        }
                                    }
                                }
                            }
                        }
                    }
                ]
            };
            return chartOption;
        }
    },
    components: {
        nbrChart
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
.md-house-detail.standard {
    width: 100%;
    background-color: #fafafd;
    @media (min-width: 601px) {
        padding: 40px;
    }
    @media (max-width: 600px) {
        padding: 20px;
    }

    .house-detail {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .mg-title {
            text-transform: uppercase;
            width: 100%;
        }
        .house-occupancy-chart {
            width: calc((100% - 20px) / 2);
            height: 400px;
            .title-wrap {
                padding: 0 20px;
            }
        }
        .listing-detail {
            border-radius: 4px;
            background-color: #fff;
            box-shadow: 0 1px 5px 0 rgba(0, 10, 30, 0.1);
            width: calc((100% - 20px) / 2);
            .title {
                width: 100%;
                height: 50px;
                padding-left: 20px;
                font-size: 16px;
                font-family: var(--font-medium);
                color: var(--color-text);
                line-height: 50px;
                border-bottom: 1px solid var(--color-border);
            }
            .table-content {
                position: relative;
                .empty-data {
                    z-index: 1;
                    position: absolute;
                    max-width: 50%;
                    width: 219px;
                    height: auto;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    img {
                        width: 100%;
                    }
                    .text {
                        text-align: center;
                        margin-top: 15px;
                        color: #c8c8c8;
                    }
                }
                .table-header {
                    height: 60px;
                    font-size: 16px;
                    font-family: var(--font-medium);
                    color: var(--color-label);
                    padding: 0 20px;
                }
                .table-body {
                    color: var(--color-disable);
                    font-size: 14px;
                    height: 283px;
                    display: flex;
                    flex-direction: column;
                    .item {
                        padding: 0 20px;
                        height: 70px;
                        &:nth-child(odd) {
                            background-color: #fafafd;
                        }
                    }
                }
                .table-header,
                .table-body .item {
                    display: flex;
                    align-items: center;
                    span {
                        display: inline-block;
                        vertical-align: middle;
                        text-align: left;
                        margin-right: 40px;
                        width: 129px;
                        &:first-of-type {
                            width: 142px;
                        }
                        &:last-of-type {
                            width: 99px;
                            margin-right: 0;
                        }
                    }
                }
            }
        }
    }
    @include media-800 {
        .house-detail {
            .house-occupancy-chart {
                width: 100%;
                .title-wrap {
                    padding: 0 15px;
                }
            }
            .listing-detail {
                width: 100%;
                .table-content {
                    .table-header span,
                    .table-body .item span {
                        width: calc((100% - 80px) / 3);
                        &:first-of-type,
                        &:last-of-type {
                            width: calc((100% - 80px) / 3);
                        }
                    }
                }
            }
        }
    }
    @include media-600 {
        background-color: #f0f1f5;
        .house-detail {
            .house-occupancy-chart {
                height: 410px;
                border-top: 1px solid var(--color-border);
            }
            .listing-detail {
                border-radius: 0;
                box-shadow: none;
                border-top: 1px solid var(--color-border);
                .title {
                    padding-left: 15px;
                    padding-top: 30px;
                    line-height: 18px;
                    border-bottom: none;
                }
                .table-content {
                    .table-header {
                        padding: 0 15px;
                        font-family: var(--font-medium);
                    }
                    .table-body {
                        height: 294px;
                        padding-bottom: 14px;
                        .item {
                            padding: 0 15px;
                        }
                    }
                    .table-header,
                    .table-body .item {
                        span {
                            width: 80px;
                            &:first-of-type {
                                width: 104px;
                            }
                            &:last-of-type {
                                width: 81px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
